/**
 * RocketAnimation — rocket flies up and off-screen with a flame trail + smoke puffs.
 * Combined with a brief starfield burst at the peak so it reads as "launched".
 */
export default function RocketAnimation({ size = 140 }) {
  return (
    <div
      className="pointer-events-none"
      style={{ width: size, height: size, position: "relative", overflow: "hidden" }}
    >
      <style>{`
        @keyframes rocket-launch {
          0%   { transform: translate(-50%, 40%) rotate(-45deg) scale(0.4); opacity: 0; }
          20%  { transform: translate(-50%, -50%) rotate(-45deg) scale(1.4); opacity: 1; }
          55%  { transform: translate(-50%, -50%) rotate(-45deg) scale(1.3); opacity: 1; }
          100% { transform: translate(-50%, -180%) rotate(-45deg) scale(0.8); opacity: 0; }
        }
        @keyframes rocket-exhaust {
          0%   { transform: translate(0, 0) scale(0.2); opacity: 0; }
          20%  { opacity: 1; }
          100% { transform: translate(var(--dx, 24px), var(--dy, 120%)) scale(1.4); opacity: 0; }
        }
        @keyframes rocket-star {
          0%   { transform: translate(-50%, -50%) scale(0); opacity: 0; }
          40%  { transform: translate(-50%, -50%) scale(1); opacity: 1; }
          100% { transform: translate(-50%, -50%) scale(0.4); opacity: 0; }
        }
      `}</style>
      {/* Exhaust puffs (rendered first, appear under rocket) */}
      {[
        { dx: "12px",  dy: "70%",  delay: "0.05s", color: "#fb923c", size: 14 },
        { dx: "22px",  dy: "90%",  delay: "0.15s", color: "#f59e0b", size: 12 },
        { dx: "0px",   dy: "110%", delay: "0.25s", color: "#f97316", size: 16 },
        { dx: "18px",  dy: "80%",  delay: "0.35s", color: "#fbbf24", size: 10 },
        { dx: "8px",   dy: "100%", delay: "0.45s", color: "#e2e8f0", size: 14 },
        { dx: "24px",  dy: "120%", delay: "0.55s", color: "#cbd5e1", size: 12 },
      ].map((p, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: "40%",
            top: "58%",
            width: p.size,
            height: p.size,
            borderRadius: "50%",
            background: p.color,
            boxShadow: `0 0 12px ${p.color}`,
            opacity: 0.9,
            animation: `rocket-exhaust 1.4s ease-out ${p.delay} forwards`,
            "--dx": p.dx,
            "--dy": p.dy,
          }}
        />
      ))}
      {/* Rocket emoji */}
      <div
        style={{
          position: "absolute",
          left: "50%",
          top: "50%",
          fontSize: size * 0.68,
          lineHeight: 1,
          animation: "rocket-launch 1.4s cubic-bezier(.5,0,.75,0) forwards",
          filter: "drop-shadow(0 0 24px rgba(251,146,60,0.9))",
        }}
      >
        🚀
      </div>
      {/* Peak star burst */}
      {[
        { dx: "-32px", dy: "-30%", delay: "0.5s" },
        { dx: "28px",  dy: "-30%", delay: "0.55s" },
        { dx: "0px",   dy: "-40%", delay: "0.6s" },
      ].map((s, i) => (
        <div
          key={i}
          style={{
            position: "absolute",
            left: `calc(50% + ${s.dx})`,
            top: `calc(50% + ${s.dy})`,
            width: 10,
            height: 10,
            background: "#fef3c7",
            transform: "rotate(45deg)",
            boxShadow: "0 0 12px #fbbf24",
            animation: `rocket-star 0.7s ease-out ${s.delay} forwards`,
          }}
        />
      ))}
    </div>
  );
}
